import React, { useState } from "react";
import { Link } from "react-router-dom";
import { SessionStatus } from "../../../constant/Types";
import { Button, Modal } from "antd";
import { PhoneFilled } from "@ant-design/icons";
import { endCallSessionService, startCallSessionService } from "../chat.api";

const STATUS = {
  CREATED:
    "تا لحظاتی دیگر با شما تماس گرفته خواهد شد از صبر و شکیبایی شما سپاسگزاریم.",
  PENDING:
    "تا لحظاتی دیگر با شما تماس گرفته خواهد شد از صبر و شکیبایی شما سپاسگزاریم.",
  STARTING:
    "تا لحظاتی دیگر با شما تماس گرفته خواهد شد از صبر و شکیبایی شما سپاسگزاریم.",
  STARTED: "ارتباط برقرار شد",
  SIP_ERROR: "خطا در برقراری تماس تیم پشتیبانی در حال بررسی و رفع مشکل هستند",
  CLIENT_NOT_ANSWER:
    "خطا در برقراری تماس تیم پشتیبانی در حال بررسی و رفع مشکل هستند",
  LAWYER_NOT_ANSWER:
    "خطا در برقراری تماس تیم پشتیبانی در حال بررسی و رفع مشکل هستند",
  ENDED: "در صورتی که به طور ناخواسته تماس شما قطع گردید برروی ادامه کلیک کنید",
};

const START_MESSAGE =
  "کاربر گرامی با انجام این عمل با شماره ثبت شده‌ شما در لاوین تا لحظاتی دیگر تماس گرفته خواهد شد آیا از در دسترس بودن شماره تماس خود مطمئن هستید؟";

const Popup = (props) => {
  const {
    sessionId,
    rootType,
    otherType,
    isChatDisabled,
    batteryInfo,
    sessionDetail,
    refresh,
  } = props;
  const { timeBased, totalRemainingTimeInSeconds } = batteryInfo;
  const { call, sessionStatus, category } = sessionDetail;
  const [loading, setLoading] = useState(false);
  const [action, setAction] = useState();

  const onStart = () => {
    setLoading(true);
    startCallSessionService(sessionId).finally(() => {
      setLoading(false);
      refresh();
      setAction(undefined);
    });
  };

  const onEnd = () => {
    setLoading(true);
    endCallSessionService(sessionId).finally(() => {
      setLoading(false);
      refresh();
      setAction(undefined);
    });
  };

  return (
    <>
      {(call || (category?.type === "call" && sessionStatus === "STARTED")) && (
        <div className="popup">
          <Modal
            open={!!action}
            onOk={action?.cb}
            onCancel={() => setAction(undefined)}
            title="توجه!"
            okText="بله"
            cancelText="خیر"
          >
            <div>{action?.msg || "آیا از اتمام مشاوره مطمئن هستید؟"}</div>
          </Modal>
          <PhoneFilled className="icon" />
          <div className="popup-text">
            {call ? STATUS[call.status] : STATUS.CREATED}
          </div>
          <div className="btn-holder call">
            {call && call.status === "ENDED" && (
              <>
                <Button
                  loading={loading}
                  className="btn"
                  onClick={() => setAction({ cb: onStart, msg: START_MESSAGE })}
                >
                  ادامه
                </Button>
                <Button
                  loading={loading}
                  className="btn btn-secondary"
                  onClick={() => setAction({ cb: onEnd })}
                >
                  پایان
                </Button>
              </>
            )}
          </div>
        </div>
      )}
      {sessionDetail.invoices && sessionDetail.invoices.length > 0 && (
        <div className="popup">
          <div className="btn-holder">
            <Link to={`/consultation/${rootType}/${sessionId}/invoice`}>
              <button className={"btn"}>پرداخت صورتحساب</button>
            </Link>
          </div>
        </div>
      )}
      {!otherType &&
        // sessionDetail.type !== "advocacy_acceptation" &&
        sessionDetail.sessionStatus !== SessionStatus.LOOKING_FOR_LAWYER &&
        !isChatDisabled &&
        sessionDetail?.sessionStatus !== SessionStatus.STARTED && (
          <div
            className={"popup"}
            // style={{ minHeight: otherType ? "auto" : "100px" }}
          >
            {!otherType && (
              <>
                {/* <div className="popup-text"> */}
                {/* جهت ارجاع به وکیل نسبت به پرداخت اقدام نمایید. */}
                {/* `پس از اتمام سوال و ارسال مدارک نسبت به پرداخت اقدام نمایید.` */}
                {/* </div> */}

                <div className="btn-holder">
                  <Link to={`/consultation/${rootType}/${sessionId}/payment`}>
                    <button className={"btn"}>تکمیل فرایند خرید</button>
                  </Link>
                </div>
              </>
            )}
          </div>
        )}
      {((isChatDisabled &&
        batteryInfo &&
        totalRemainingTimeInSeconds === 0 &&
        sessionDetail.sessionStatus !== SessionStatus.STARTED &&
        sessionDetail?.sessionStatus !== SessionStatus.CLOSED_BY_ADMIN &&
        sessionDetail?.sessionStatus !== SessionStatus.CLOSED) ||
        (sessionDetail.sessionStatus === SessionStatus.RECHARGE_NEEDED &&
          !timeBased)) && (
        <div
          className={"popup"}
          style={{ minHeight: otherType ? "auto" : "100px" }}
        >
          <div className="popup-text">
            برای ادامه مشاوره نیاز به شارژ مجدد است
          </div>
          <div className="btn-holder">
            <Link to={`/consultation/${rootType}/${sessionId}/payment`}>
              <button className={"btn"}>تکمیل فرایند خرید</button>
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default Popup;
